<template>

    <div class="review">

        <transition name="modal">
            <v-modal-review-delete v-if="modal === 'review-delete-' + review.id" :review-id="review.id" @saved="$emit('saved')" />
            <v-modal-review-edit v-if="modal === 'review-edit-' + review.id" :review-id="review.id" @saved="$emit('saved')" />
        </transition>

        <div class="review-header">
            <v-star-rating v-if="review.rating" :score="review.rating.score" :color="review.rating.color" :size="15" />
        </div>

        <div class="review-body">
            <div class="text mb-15" v-if="text">
                <span v-html="text" />
            </div>
            <div class="footer">
                <span v-if="review.source">
                    <i class="fas fa-comment mr-5" /><router-link :to="{ 'name': 'reviews', 'query': { 'source_id': review.source.id } }">{{ review.source.name }}</router-link>
                </span>
                <span v-if="review.location">
                    <i class="fas fa-map-marker-alt mr-5" /><router-link :to="{ 'name': 'reviews', 'query': { 'location_id': review.location.id } }">{{ review.location.name }}</router-link>
                </span>
                <span v-if="review.tags && review.tags.length">
                    <i class="fas fa-tag mr-5" />
                    <span v-for="(tag, index) in review.tags" :key="tag.uuid">
                        <router-link :to="{ 'name': 'reviews', 'query': { 'tag_id': tag.id } }">{{ tag.name }}</router-link><span v-if="index < review.tags.length - 1">, </span>
                    </span>
                </span>
                <span>{{ review.created_at | date }}</span>
            </div>
        </div>

        <div class="review-footer">
            <div></div>
            <v-button-toolbar>
                <v-button size="xs" theme="white" @click.native="$router.push({ name: 'reviews.show', params: { id: review.id } })" arrow>{{ $t('labels.view') }}</v-button>
            </v-button-toolbar>
        </div>

    </div>

</template>

<style scoped lang="scss">

    .review {
        @include light-theme;
        background: $color-white;
        border: 1px solid $color-rule;
        border-radius: 5px;
        overflow: hidden;
        position: relative;
    }

    .review-header {
        padding: 30px 30px 15px 30px;
    }

    .review-body {
        padding: 0 30px 30px 30px;
        .text {
            @include font-regular(15px);
            color: $color-text;
            line-height: 1.6em;
            p {
                color: inherit;
                font-family: inherit;
                font-size: inherit;
                font-weight: inherit;
                line-height: inherit;
                margin: 0;
                padding: 0;
            }
        }
        .footer {
            @include font-regular(13px);
            line-height: 1.6em;
            a {
                color: $color-muted;
            }
            > span {
                color: $color-muted;
                margin-left: 5px;
                &:first-child {
                    margin: 0;
                    &::before {
                        display: none;
                    }
                }
                &::before {
                    content: "•";
                    display: inline;
                    padding-right: 5px;
                }
            }
        }
    }

    .review-footer {
        background: $color-bg;
        display: flex;
        justify-content: space-between;
        padding: 15px;
    }

</style>

<script>

import StarRating from '@cmp/StarRating';
import ModalReviewDelete from '@modals/ModalReviewDelete';
import ModalReviewEdit from '@modals/ModalReviewEdit';
import StringUtil from '@utils/StringUtil';

export default {

    components: {
        'v-modal-review-delete': ModalReviewDelete,
        'v-modal-review-edit': ModalReviewEdit,
        'v-star-rating': StarRating,
    },

    props: {
        review: {
            type: Object,
            required: true,
        },
    },

    computed: {

        text() {
            const review = this.review.review_html || this.review.review;
            return review ? StringUtil.formatHtml(review) : null;
        },

        customer() {
            return this.review.customer;
        },

    },

}

</script>